import React from 'react';

const SECOES = [
  { id: 'dados-gerais',  label: 'Dados Gerais',       icon: '🏢', chave: 'dadosGerais' },
  { id: 'empresas',      label: 'Empresas (CNPJs)',   icon: '🏭', chave: 'empresas' },
  { id: 'modulos',       label: 'Módulos',             icon: '⚙️', chave: 'modulos' },
  { id: 'anexos',        label: 'Anexos',              icon: '📎', chave: 'anexos' },
  { id: 'usuarios',      label: 'Usuários do Sistema', icon: '👤', chave: 'usuarios' },
];

function StatusIcon({ pct }) {
  if (pct === 100) return <span className="text-green-500 text-base">✓</span>;
  if (pct > 0)     return <span className="text-amber-400 text-base">◔</span>;
  return <span className="text-gray-300 text-base">○</span>;
}

export default function Sidebar({ secaoAtiva, onNavegar, porSecao = {}, finalizado }) {
  return (
    <aside className="w-56 shrink-0 bg-white border-r border-gray-100 min-h-screen pt-4 pb-8 flex flex-col">
      {finalizado && (
        <div className="mx-3 mb-4 px-3 py-2 bg-green-50 border border-green-200 rounded-lg">
          <p className="text-xs font-semibold text-green-700">✅ Onboarding finalizado</p>
          <p className="text-xs text-green-600 mt-0.5">Somente leitura</p>
        </div>
      )}

      <nav className="flex-1 space-y-0.5 px-2">
        {SECOES.map(s => {
          const ativa = secaoAtiva === s.id;
          const pct = porSecao[s.chave] ?? 0;
          return (
            <button
              key={s.id}
              onClick={() => onNavegar(s.id)}
              className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all text-left ${
                ativa
                  ? 'bg-brand-100 text-brand-800'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              }`}
            >
              <span className="text-base w-5 text-center">{s.icon}</span>
              <span className="flex-1 truncate">{s.label}</span>
              <StatusIcon pct={pct} />
            </button>
          );
        })}
      </nav>

      <div className="px-4 mt-6">
        <p className="text-xs text-gray-400 text-center leading-relaxed">
          HeadThink Soluções<br />
          <a href="mailto:suporte@headthink.com.br" className="text-brand-500 hover:underline">
            Precisa de ajuda?
          </a>
        </p>
      </div>
    </aside>
  );
}
